import { createSelector } from 'reselect';

const paypalOneClickSessionsSelector = state => state.paypalOneClickSession

export const paypalOneClickSessionSelector = createSelector([paypalOneClickSessionsSelector], (paypalOneClickSession) => { 
    return paypalOneClickSession?.paypalOneClickSessionId});
